import { mode } from '@chakra-ui/theme-tools';

function baseStyleTrack(props) {
  var {
    colorScheme: c
  } = props;
  return {
    borderRadius: 'full',
    p: '2px',
    transition: 'all 120ms',
    bg: mode('gray.300', 'whiteAlpha.400')(props),
    _focus: {
      boxShadow: 'none'
    },
    _disabled: {
      opacity: 0.4,
      cursor: 'not-allowed'
    },
    _checked: {
      bg: mode(c + ".500", c + ".200")(props)
    }
  };
}

var baseStyle = props => ({
  track: baseStyleTrack(props)
});

var defaultProps = {
  size: 'md',
  colorScheme: 'brand'
};
export default {
  baseStyle,
  defaultProps
};
//# sourceMappingURL=Switch.js.map